<template>
  <div >
    <div class="footer-bg">
    <div class="indexLine mb28"></div>
    <div class=" lh-100 center-block footer">
      <div class="pull-left pt18">
        <span class="block h28 lh28">服务电话：&nbsp;&nbsp;0571-89978771（或0571-89978775）</span>
        <!-- <span class="block h28 lh28">合作伙伴：&nbsp;&nbsp;<a href="http://www.giian.com/index1.asp" target="_blank" class="commonhover">建安检测研究院有限公司</a><i class="pl10 pr10">|</i><a href="http://115.29.207.187:81/index.asp" target="_blank" class="commonhover">中辐环境科技有限公司</a></span> -->
        <span class="block h28 lh28">邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：&nbsp;&nbsp;smarthse@smarthse.cn</span>
      </div>
      <div class="pull-right">
        <img src="static/images/sehs-ewm2.jpg" alt="" class="mb16 offical-Qcode">
        <span class="text-center block color-white">企业微信公众号</span>
      </div>

      <div class="clear"></div>
      </div>
    </div>
      <div class="beian"><img src="static/images/offical-beian.png" alt="" class="vertical-m"><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602002264" target="_blank" class="commonhover">&nbsp;&nbsp;&nbsp;&nbsp;浙公网安备33010602002264号</a><i></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&copy;智慧职安环保科技有限公司版权所有<span><a href="http://www.beian.miit.gov.cn" target="_blank" class="commonhover">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;浙ICP备16005120号-1</a></span></div>

    </div>
</template>

<script>
 
export default {
  name: 'footerApp',
  data () {
    return {
    
      
      
    }
  },
  methods:{
   
  },
  components:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer-bg{
  background: #005580;
  color:#86b8d2;
}
.indexLine{
  width: 100%;
  height: 1px;
  background-color:#e1e4e6;
  top:28px;
}
.footer{/* padding-left: 200px; */padding:0 19.4% 24px;/* padding-right: 200px; */}
.beian{margin:0 auto; height: 30px;line-height: 30px;text-align: center;color:#86b8d2;font-size: 12px;background-color: #004365;}
.offical-Qcode-bg{width: 90px;height: 90px;background-color: #fff;margin-bottom: 12px;}
.offical-Qcode{width: 100px;height: 100px;margin-bottom: 10px;}
.commonhover:hover{color:#fff;}
@media (max-width: 1240px){
  .footer{
    padding:0 24% 24px;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/common/footerApp.vue